import { checkMaintenanceExclude, defineNuxtRouteMiddleware, navigateTo, useRuntimeConfig } from "#imports";
export default defineNuxtRouteMiddleware(async (to, _from) => {
  const config = useRuntimeConfig();
  if (!config.public.maintenance.enabled) {
    if (to.path === "/maintenance") {
      return navigateTo("/");
    }
    return;
  }
  if (to.path === "/maintenance") {
    return;
  }
  const isExcluded = checkMaintenanceExclude(to.path, config.public.maintenance.exclude);
  if (isExcluded) {
    return;
  }
  return navigateTo("/maintenance");
});
